import React from 'react';

export default function GuidesSection({ theme = 'light' }) {
  const isDark = theme === 'dark';

  return (
    <div className="flex flex-col gap-y-1">
      <h4 className={`font-semibold mb-0 ${isDark ? 'text-white' : ''}`}>Guides</h4>
      <ul className={isDark ? 'text-gray-400' : 'text-content-secondary'}>
        {[
          {
            title: 'COE Results & History',
            url: '/coe-history/',
          },
          {
            title: 'Articles',
            url: '/articles',
          },
        ].map((item) => (
          <li key={item.title}>
            <a
              className={`${isDark ? 'text-gray-400 visited:text-gray-400' : 'text-content-secondary visited:text-content-secondary'} leading-relaxed hover:text-gray-300`}
              href={item.url}
              target={item.external ? '_blank' : '_self'}
              rel={item.external ? 'noreferrer' : ''}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
